import React, { useEffect, useState, Suspense, lazy, createElement } from 'react';
import { CheckCircle2, Star, Menu, X, ShieldCheck, Zap, Globe, Lock } from 'lucide-react';
const UpsellPopup = lazy(() => import('./components/UpsellPopup').then(m => ({
  default: m.UpsellPopup
})));
const SalesNotification = lazy(() => import('./components/SalesNotification').then(m => ({
  default: m.SalesNotification
})));
export function App() {
  const [isUpsellOpen, setIsUpsellOpen] = useState(false);
  const [isNavOpen, setIsNavOpen] = useState(false);
  const PRICE = '6.39';
  const STICKER_PRICE = '97.00';
  useEffect(() => {
    const preconnects = [{
      href: 'https://cdn.shopify.com',
      crossOrigin: 'anonymous'
    }, {
      href: 'https://fonts.gstatic.com',
      crossOrigin: 'anonymous'
    }];
    preconnects.forEach(({
      href,
      crossOrigin
    }) => {
      const link = document.createElement('link');
      link.rel = 'preconnect';
      link.href = href;
      if (crossOrigin) link.crossOrigin = crossOrigin;
      document.head.appendChild(link);
    });
    const fontLink = document.createElement('link');
    fontLink.rel = 'stylesheet';
    fontLink.href = 'https://fonts.googleapis.com/css2?family=Inter:wght@400;700;800;900&display=swap';
    fontLink.media = 'print';
    fontLink.onload = function () {
      fontLink.media = 'all';
    };
    document.head.appendChild(fontLink);
    const preloadLink = document.createElement('link');
    preloadLink.rel = 'preload';
    preloadLink.as = 'image';
    preloadLink.href = 'https://cdn.shopify.com/s/files/1/0981/0781/8286/files/ChatGPT_Image_10_abr_2026_07_46_03_p.m._1_1.png?v=1775864834';
    preloadLink.setAttribute('fetchpriority', 'high');
    document.head.appendChild(preloadLink);
    try {
      if (typeof window !== 'undefined' && !(window as any).fbq) {
        ;
        (function (f: any, b: any, e: any, v: any) {
          var n: any, t: any, s: any;
          if (f.fbq) return;
          n = f.fbq = function () {
            n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
          };
          if (!f._fbq) f._fbq = n;
          n.push = n;
          n.loaded = true;
          n.version = '2.0';
          n.queue = [];
          t = b.createElement(e);
          t.async = true;
          t.src = v;
          s = b.getElementsByTagName(e)[0];
          s.parentNode.insertBefore(t, s);
        })(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');
        (window as any).fbq('init', '919180517627113');
        (window as any).fbq('track', 'PageView');
        (window as any).fbq('track', 'ViewContent', {
          content_name: 'THE 888 CODE - Neuro-Quantum Programming System',
          content_ids: ['51940662772014'],
          content_type: 'product',
          value: 6.39,
          currency: 'USD'
        });
        const noscriptImg = document.createElement('img');
        noscriptImg.height = 1;
        noscriptImg.width = 1;
        noscriptImg.style.display = 'none';
        noscriptImg.src = 'https://www.facebook.com/tr?id=919180517627113&ev=PageView&noscript=1';
        document.body.appendChild(noscriptImg);
      }
    } catch (e) {
      console.warn('Facebook Pixel failed to load:', e);
    }
  }, []);
  const handlePurchase = () => {
    try {
      if (typeof window !== 'undefined' && (window as any).fbq) {
        ;
        (window as any).fbq('track', 'InitiateCheckout', {
          content_name: 'THE 888 CODE - Neuro-Quantum Programming System',
          content_ids: ['51940662772014'],
          content_type: 'product',
          value: 6.39,
          currency: 'USD'
        });
      }
    } catch (e) {
      console.warn('Facebook Pixel InitiateCheckout failed:', e);
    }
    setIsUpsellOpen(true);
  };
  const valueStack = [{
    name: 'THE 888 CODE: Master Manual',
    price: '$47',
    desc: 'Neuro-Biological Intervention Guide (60 Pages).'
  }, {
    name: 'BONUS #1: 888 Alpha Symphony',
    price: '$27',
    desc: 'High-Fidelity Binaural Real-Time Audio.'
  }, {
    name: 'BONUS #2: The Quantum Flow Planner',
    price: '$13',
    desc: 'Daily GPS for financial opportunity alignment.'
  }, {
    name: 'BONUS #3: Liquid Gold Master Keys',
    price: '$10',
    desc: '33 High-Frequency Decrees for instant materialization.'
  }];
  return <div className="min-h-screen bg-[#0A0A0B] font-sans text-white selection:bg-yellow-500/30 overflow-x-hidden w-full" data-id="element-0">
      <a href="#main-content" className="sr-only focus:not-sr-only focus:absolute focus:top-2 focus:left-2 focus:z-[99999] focus:bg-[#D4AF37] focus:text-black focus:px-4 focus:py-2 focus:rounded focus:font-bold" data-id="element-1">
        Skip to main content
      </a>

      {/* NAVBAR */}
      <nav className="sticky top-0 z-[999] bg-[#0A0A0B]/95 border-b border-yellow-500/10 h-[70px] flex items-center justify-between px-[5%] backdrop-blur-md" data-id="element-2">
        <div className="font-serif italic text-[#D4AF37] text-xl font-black tracking-[2px]" data-id="element-3">
          THE 888 CODE
        </div>
        <div className="hidden lg:flex items-center gap-8" data-id="element-4">
          <a href="#science" className="text-[10px] font-black uppercase tracking-widest hover:text-[#D4AF37] transition-colors" data-id="element-5">
            Science
          </a>
          <a href="#results" className="text-[10px] font-black uppercase tracking-widest hover:text-[#D4AF37] transition-colors" data-id="element-6">
            Results
          </a>
          <button onClick={handlePurchase} className="bg-[#D4AF37] text-black text-[11px] font-black px-6 py-2.5 rounded shadow-lg shadow-yellow-500/20 uppercase tracking-tighter hover:scale-105 transition-transform" data-id="element-7">
            ACTIVATE NOW - ${PRICE}
          </button>
        </div>
        <button className="lg:hidden text-[#D4AF37]" onClick={() => setIsNavOpen(!isNavOpen)} aria-label="Toggle menu" data-id="element-8">
          {isNavOpen ? <X size={28} data-id="element-9" /> : <Menu size={28} data-id="element-10" />}
        </button>
      </nav>

      <main id="main-content" data-id="element-11">
        {/* HERO SECTION */}
        <section className="relative px-[5%] py-16 md:py-20 flex flex-col items-center text-center overflow-hidden min-h-[80vh] sm:min-h-[90vh] justify-center" data-id="element-12">
          <div className="absolute inset-0 z-0 opacity-40" style={{
          backgroundImage: "url('https://cdn.shopify.com/s/files/1/0981/0781/8286/files/El_Hero_Visual_Fondo_de_red_neuronal.png?v=1775547360')",
          backgroundSize: 'cover',
          backgroundPosition: 'center'
        }} data-id="element-13" />
          <div className="absolute inset-0 bg-gradient-to-b from-[#0A0A0B] via-transparent to-[#0A0A0B] z-[1]" data-id="element-14" />

          <div className="relative z-10 max-w-4xl animate-fadeInUp" data-id="element-15">
            <span className="inline-block bg-yellow-500/10 text-[#D4AF37] px-4 py-1.5 rounded-full text-[10px] font-black tracking-[3px] mb-6 uppercase border border-yellow-500/20" data-id="element-16">
              IMMEDIATE ACCESS OFFER
            </span>
            <h1 className="font-serif text-4xl sm:text-5xl md:text-7xl lg:text-8xl leading-[1.1] font-black mb-6" data-id="element-17">
              NEURO-QUANTUM <br data-id="element-18" />
              <span className="text-[#D4AF37]" data-id="element-19">PROGRAMMING</span>
            </h1>
            <p className="text-base sm:text-lg md:text-xl opacity-90 leading-relaxed mb-10 max-w-2xl mx-auto" data-id="element-20">
              Synchronize your nervous system with the frequency of abundance
              and eliminate scarcity blocks in 15 minutes.
            </p>
            <div className="flex flex-col items-center gap-4" data-id="element-21">
              <button onClick={handlePurchase} className="bg-[#D4AF37] text-black py-5 px-8 sm:py-6 sm:px-12 text-lg sm:text-xl font-black rounded-xl shadow-[0_20px_60px_rgba(212,175,55,0.4)] hover:scale-105 transition-all w-full max-w-md" data-id="element-22">
                DOWNLOAD - ${PRICE}
              </button>
              <p className="text-[9px] sm:text-[10px] font-bold text-[#D4AF37] tracking-[2px] sm:tracking-[3px] uppercase mt-2" data-id="element-23">
                ⚡ DIGITAL ACCESS • ONE-TIME PAYMENT
              </p>
            </div>
          </div>

          <div className="mt-12 md:mt-16 relative z-10 w-full flex justify-center" data-id="element-24">
            <img src="https://cdn.shopify.com/s/files/1/0981/0781/8286/files/ChatGPT_Image_10_abr_2026_07_46_03_p.m._1_1.png?v=1775864834" alt="The 888 Manual" className="w-full max-w-[280px] sm:max-w-[350px] md:max-w-[480px] drop-shadow-[0_50px_100px_rgba(0,0,0,0.9)] animate-float" loading="eager" data-id="element-25" />
          </div>
        </section>

        {/* THE ORDER OF LIQUID GOLD */}
        <section id="frequency" className="py-16 md:py-24 px-[5%] bg-[#0A0A0B] border-t border-white/5" data-id="element-26">
          <div className="max-w-6xl mx-auto grid grid-cols-1 lg:grid-cols-2 gap-10 lg:gap-16 items-center" data-id="element-27">
            <div className="order-2 lg:order-1 relative" data-id="element-28">
              <img src="https://cdn.shopify.com/s/files/1/0981/0781/8286/files/La_Frecuencia_888_Visualizacion_del_Sonido.png?v=1775547349" alt="Liquid Gold Cymatics" className="w-full rounded-2xl border border-yellow-500/20 shadow-2xl" loading="lazy" data-id="element-29" />
            </div>
            <div className="order-1 lg:order-2" data-id="element-30">
              <h2 className="font-serif text-3xl sm:text-4xl md:text-5xl font-black mb-6 md:mb-8 leading-tight" data-id="element-31">
                The Order of <br data-id="element-32" />
                <span className="text-[#D4AF37]" data-id="element-33">Liquid Gold</span>
              </h2>
              <p className="text-base sm:text-lg opacity-80 leading-relaxed mb-8 sm:mb-10" data-id="element-34">
                The 888Hz frequency generates sacred geometry patterns in the
                water of your cells. Where there was once chaos and debt, The
                888 Code introduces <b className="text-white" data-id="element-35">Order and Flow</b>
                .
              </p>
              <ul className="space-y-4 sm:space-y-6" data-id="element-36">
                {['Hemispheric Synchronization.', 'Elimination of Financial Cortisol.', 'Activation of Business Intuition.'].map((text, idx) => <li key={idx} className="flex items-center gap-3 sm:gap-4 group" data-id="element-37">
                    <span className="text-[#D4AF37] font-black text-xs tracking-[2px]" data-id="element-38">
                      888
                    </span>
                    <span className="font-bold text-white/90 text-sm sm:text-base group-hover:text-[#D4AF37] transition-colors" data-id="element-39">
                      {text}
                    </span>
                  </li>)}
              </ul>
            </div>
          </div>
        </section>

        {/* BIO-DIGITAL INTERVENTION */}
        <section id="science" className="relative py-20 sm:py-32 px-[5%] overflow-hidden flex items-center min-h-[50vh]" data-id="element-40">
          <div className="absolute inset-0 z-0 opacity-40" style={{
          backgroundImage: "url('https://cdn.shopify.com/s/files/1/0981/0781/8286/files/El_Hero_Visual_Fondo_de_red_neuronal.png?v=1775547360')",
          backgroundSize: 'cover',
          backgroundPosition: 'center'
        }} data-id="element-41" />
          <div className="absolute inset-0 bg-gradient-to-r from-[#0A0A0B] via-[#0A0A0B]/80 to-transparent z-[1]" data-id="element-42" />

          <div className="relative z-10 max-w-2xl" data-id="element-43">
            <span className="text-[#D4AF37] text-xs font-black tracking-[4px] uppercase mb-4 block" data-id="element-44">
              Applied Science
            </span>
            <h2 className="font-serif text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-black mb-6 md:mb-8 leading-tight" data-id="element-45">
              Bio-Digital <br data-id="element-46" />
              <span className="text-[#D4AF37]" data-id="element-47">Intervention</span>
            </h2>
            <p className="text-base sm:text-lg opacity-90 leading-relaxed mb-8 sm:mb-10" data-id="element-48">
              The 888 Code is not a simple meditation. It is an acoustic signal
              designed to reprogram your{' '}
              <b className="text-white" data-id="element-49">Reticular Activating System (RAS)</b>,
              physically eliminating the neural grooves of scarcity.
            </p>
            <div className="flex flex-wrap gap-2 sm:gap-3" data-id="element-50">
              {['Neuro-Plasticity', 'Theta Waves', 'Solfeggio Frequencies'].map((pill, i) => <span key={i} className="border border-[#D4AF37] text-[#D4AF37] px-3 sm:px-4 py-1.5 text-[9px] sm:text-[10px] font-black uppercase rounded-full tracking-widest" data-id="element-51">
                    {pill}
                  </span>)}
            </div>
          </div>
        </section>

        {/* QUANTUM RESULTS */}
        <section id="results" className="py-16 md:py-24 px-[5%] bg-[#0A0A0B] text-center" data-id="element-52">
          <h2 className="font-serif text-3xl sm:text-4xl md:text-5xl font-black mb-3 sm:mb-4" data-id="element-53">
            QUANTUM <span className="text-[#D4AF37]" data-id="element-54">RESULTS</span>
          </h2>
          <p className="text-white/60 mb-12 md:mb-16 max-w-2xl mx-auto text-sm sm:text-base" data-id="element-55">
            Real people experiencing real financial transformations by tuning
            into the right frequency.
          </p>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8 max-w-6xl mx-auto" data-id="element-56">
            {[{
            name: 'James M.',
            loc: 'AUSTIN, TEXAS',
            text: "I had been stagnant in my income for years. 14 days after listening to the audio and applying the manual, I closed the biggest contract of my life. It seems like magic, but it's frequency."
          }, {
            name: 'Sarah V.',
            loc: 'DENVER, COLORADO',
            text: 'My relationship with money was pure stress. The 888 Code reprogrammed my anxiety. Now money flows to me in unexpected ways. Totally recommended.'
          }, {
            name: 'Michael R.',
            loc: 'MIAMI, FLORIDA',
            text: "I was skeptical about 'quantum programming'. But the results speak for themselves. I multiplied my income sources in less than a month. It's a ridiculous investment for what you get."
          }].map((t, i) => <div key={i} className="bg-[#111112] border border-white/5 p-6 sm:p-8 rounded-2xl text-left relative group hover:border-[#D4AF37]/30 transition-all" data-id="element-57">
                <div className="flex text-[#D4AF37] mb-4 sm:mb-6" data-id="element-58">
                  {[...Array(5)].map((_, s) => <Star key={s} size={16} fill="currentColor" data-id="element-59" />)}
                </div>
                <p className="italic mb-8 sm:mb-10 opacity-80 leading-relaxed text-sm sm:text-base group-hover:opacity-100 transition-opacity" data-id="element-60">
                  "{t.text}"
                </p>
                <div className="flex items-center gap-3 sm:gap-4 border-t border-white/10 pt-4 sm:pt-6" data-id="element-61">
                  <div className="w-10 h-10 rounded-full bg-[#D4AF37]/20 flex items-center justify-center font-bold text-[#D4AF37] shrink-0" data-id="element-62">
                    {t.name.charAt(0)}
                  </div>
                  <div data-id="element-63">
                    <p className="font-bold text-xs sm:text-sm uppercase tracking-wide" data-id="element-64">
                      {t.name}
                    </p>
                    <p className="text-[9px] sm:text-[10px] text-[#D4AF37] font-black tracking-widest" data-id="element-65">
                      {t.loc}
                    </p>
                  </div>
                </div>
              </div>)}
          </div>
        </section>

        {/* IDENTITY SECTION */}
        <section className="relative min-h-[60vh] sm:min-h-[80vh] flex flex-col justify-end items-center pb-16 sm:pb-24 px-[5%] bg-cover bg-center" style={{
        backgroundImage: "url('https://cdn.shopify.com/s/files/1/0981/0781/8286/files/Retrato_del_Manifestador_El_Ideal_del_Cliente.png?v=1775547355')"
      }} data-id="element-66">
          <div className="absolute inset-0 bg-gradient-to-t from-[#0A0A0B] via-transparent to-transparent z-[1]" data-id="element-67" />
          <div className="relative z-10 text-center max-w-3xl" data-id="element-68">
            <h3 className="font-serif italic text-2xl sm:text-3xl md:text-5xl text-white mb-6 sm:mb-8 drop-shadow-2xl leading-tight" data-id="element-69">
              "My mind finally speaks the same language as money."
            </h3>
            <button onClick={handlePurchase} className="bg-[#D4AF37] text-black py-4 px-8 sm:py-5 sm:px-10 text-base sm:text-lg font-bold rounded-xl shadow-2xl hover:scale-105 transition-all" data-id="element-70">
              TRY THE CODE FOR ${PRICE}
            </button>
          </div>
        </section>

        {/* THE COMPLETE PROTOCOL */}
        <section className="py-16 md:py-24 px-[5%] bg-[#0A0A0B]" data-id="element-71">
          <div className="max-w-5xl mx-auto border border-[#D4AF37]/30 rounded-2xl p-8 sm:p-10 md:p-14" data-id="element-72">
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 lg:gap-16 items-start" data-id="element-73">
              {/* Left Column */}
              <div data-id="element-74">
                <h2 className="font-serif text-3xl sm:text-4xl md:text-5xl font-black leading-tight mb-4" data-id="element-75">
                  THE COMPLETE
                  <br data-id="element-76" />
                  <span className="text-[#D4AF37]" data-id="element-77">PROTOCOL</span>
                </h2>
                <p className="text-white/60 text-sm sm:text-base mb-8 leading-relaxed" data-id="element-78">
                  Everything you need to start your neuro-quantum reprogramming
                  today.
                </p>

                <ul className="space-y-5" data-id="element-79">
                  {['Abundance Master Manual (High-Res PDF)', '888Hz Frequency Audio (High-Fidelity MP3)', '21-Day Activation Guide', 'Nighttime Reprogramming Protocol', 'Immediate and Lifetime Access', '2026 Updates Included'].map((item, index) => <li key={index} className="flex items-center gap-3" data-id="element-80">
                      <CheckCircle2 className="text-[#D4AF37] shrink-0" size={20} data-id="element-81" />
                      <span className="text-white font-semibold text-sm sm:text-base" data-id="element-82">
                        {item}
                      </span>
                    </li>)}
                </ul>
              </div>

              {/* Right Column - Pricing Card */}
              <div className="bg-[#111112] border border-[#D4AF37]/30 rounded-2xl p-8 sm:p-10 flex flex-col items-center text-center" data-id="element-83">
                <p className="text-[#D4AF37] font-black text-5xl sm:text-6xl mb-3" data-id="element-84">
                  ${PRICE}
                </p>
                <p className="text-white/60 text-sm mb-8" data-id="element-85">
                  One-time payment. No hidden subscriptions.
                </p>

                <button onClick={handlePurchase} className="w-full bg-[#D4AF37] text-black py-4 sm:py-5 rounded-xl font-black uppercase text-base sm:text-lg shadow-[0_15px_40px_rgba(212,175,55,0.3)] hover:bg-yellow-400 transition-all mb-6" data-id="element-86">
                  DOWNLOAD ${PRICE}
                </button>

                <div className="flex items-center gap-2 text-white/50 text-xs" data-id="element-87">
                  <Lock size={14} className="text-[#D4AF37]" data-id="element-88" />
                  <span data-id="element-89">100% Secure and Encrypted Purchase</span>
                </div>
              </div>
            </div>
          </div>
        </section>
      </main>

      {/* FOOTER */}
      <footer className="py-12 md:py-20 px-[5%] text-center border-t border-white/5 bg-[#0A0A0B]" data-id="element-90">
        <div className="font-serif italic text-[#D4AF37] text-lg mb-6 sm:mb-8 tracking-widest uppercase" data-id="element-91">
          The 888 Code
        </div>
        <p className="text-[9px] sm:text-[10px] font-bold tracking-[2px] sm:tracking-[3px] leading-loose max-w-3xl mx-auto opacity-30 uppercase" data-id="element-92">
          © 2026 THE 888 CODE • POWERED BY BETTER DAILY GUIDES <br data-id="element-93" />
          FACEBOOK IS A REGISTERED TRADEMARK OF META, INC. THIS SITE IS NOT PART
          OF FACEBOOK. <br data-id="element-94" />
          RESULTS ARE NOT TYPICAL. INDIVIDUAL EFFORT REQUIRED.
        </p>
      </footer>

      {/* MOBILE OVERLAY */}
      {isNavOpen && <div className="fixed inset-0 bg-black/95 z-[1000] flex flex-col items-center justify-center p-8 sm:p-10" data-id="element-95">
          <button className="absolute top-8 right-8 sm:top-10 sm:right-10 text-[#D4AF37]" onClick={() => setIsNavOpen(false)} aria-label="Close menu" data-id="element-96">
            <X size={32} data-id="element-97" />
          </button>
          <a href="#science" onClick={() => setIsNavOpen(false)} className="text-xl sm:text-2xl font-black mb-8 sm:mb-10 uppercase tracking-widest text-[#D4AF37]" data-id="element-98">
            Science
          </a>
          <a href="#results" onClick={() => setIsNavOpen(false)} className="text-xl sm:text-2xl font-black mb-8 sm:mb-10 uppercase tracking-widest text-[#D4AF37]" data-id="element-99">
            Results
          </a>
          <button onClick={() => {
        setIsNavOpen(false);
        handlePurchase();
      }} className="bg-[#D4AF37] text-black py-4 px-10 sm:py-5 sm:px-12 text-lg sm:text-xl font-black rounded-xl" data-id="element-100">
            ACTIVATE - ${PRICE}
          </button>
        </div>}

      <Suspense fallback={null} data-id="element-101">
        <SalesNotification data-id="element-102" />
      </Suspense>
      <Suspense fallback={null} data-id="element-103">
        <UpsellPopup isOpen={isUpsellOpen} onClose={() => setIsUpsellOpen(false)} data-id="element-104" />
      </Suspense>
    </div>;
}